/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { ActionHistory } from '@trello/action-history';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { Auth } from 'app/scripts/db/Auth';
import ReactDOM from '@trello/react-dom-wrapper';
import React from 'react';
import { ApiError } from '@trello/error-handling';
import { Card } from 'app/scripts/models/card';
import { containsValidUrl } from 'app/scripts/lib/util/url/contains-valid-url';
import inviteAddNameTemplate from 'app/scripts/views/templates/invite_add_name';
import { getKey, Key } from '@trello/keybindings';
import { l } from 'app/scripts/lib/localize';
import { localizeServerError } from 'app/scripts/lib/localize-server-error';
import { maybeDisplayMemberLimitsError } from 'app/scripts/views/board-menu/MemberLimitsError';
import { ModelCache } from 'app/scripts/db/model-cache';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import Promise from 'bluebird';
import { SelectMemberOnCardView } from 'app/scripts/views/member/SelectMemberOnCardView';
import { InviteMemberAutocompleteMultiBoardGuestAlert } from 'app/scripts/views/organization/InviteMemberAutocompleteMultiBoardGuestAlert';
import { Util } from 'app/scripts/lib/util';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { View } from 'app/scripts/views/internal/view';
import _ from 'underscore';
import template from 'app/scripts/views/templates/popover_select_members';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { searchFilter } from 'app/scripts/lib/util/text/search-filter';
import { sendErrorEvent } from '@trello/error-reporting';
import { isDesktop as _isDesktop } from '@trello/browser';
const isDesktop = _isDesktop();

const MAX_EXPANDED_MEMBERS = 9;
const MAX_SUGGESTIONS = 5;

class CardMemberSelectView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'members';

    this.prototype.events = {
      'click .js-board-members .js-select-member': 'selectMem',
      'click .js-org-members .js-select-member': 'selectMem',
      'click .js-suggestions .js-select-member': 'addSuggestedMember',
      'click .js-show-org-members': 'showOrgMembers',
      'mouseenter .pop-over-member-list .item': 'hoverMemberSelect',
      'input .js-search-mem'(e) {
        this.updateSearch();
        return this.renderSuggested();
      },

      keydown: 'keydownEvent',

      // send email invite to new email address
      'click .js-send-email-invite': 'sendEmailInvite',
      'submit .js-email-data': 'sendEmailInvite',
    };
  }

  constructor(options) {
    super(options);
    this.wouldBecomeBillableGuest = this.wouldBecomeBillableGuest.bind(this);
  }

  initialize() {
    this.showAllOrgMembers = false;
    this.wouldBecomeBillableGuestPromise = null;

    this.updateSearch = _.debounce(this.updateSearch, 100);

    this.makeDebouncedMethods('renderMems', 'renderSuggested');

    // If the @model is a Card Composer, there won't be a memberList we have to
    // watch
    if (this.model.memberList != null) {
      this.listenTo(this.model.memberList, 'add remove reset', () => {
        this.updateOrdering();
        this.renderMemsDebounced();
        return this.renderSuggestedDebounced();
      });
    }

    Analytics.sendScreenEvent({
      name: 'cardMemberSelectInlineDialog',
      containers: this.model.getBoard().getAnalyticsContainers(),
      attributes: {
        cardIsTemplate: this.model.get('isTemplate'),
        cardIsClosed: this.model.get('closed'),
      },
    });

    return this.updateOrdering();
  }

  remove() {
    if (this.reactRoot) {
      ReactDOM.unmountComponentAtNode(this.reactRoot);
    }
    return super.remove(...arguments);
  }

  updateOrdering() {
    this._onCardMembers = {};
    this._onListMembers = {};
    this._onBoardMembers = {};

    const addCardMembers = (target, card) =>
      card.memberList.forEach((member) => (target[member.id] = true));
    // Might be the card composer
    if (this.model instanceof Card) {
      addCardMembers(this._onCardMembers, this.model);
    }
    this.model
      .getList()
      .cardList.forEach(addCardMembers.bind(null, this._onListMembers));
    return this.model.getBoard().listList.forEach((list) => {
      return list.cardList.forEach(
        addCardMembers.bind(null, this._onBoardMembers),
      );
    });
  }

  render() {
    const board = this.model.getBoard();

    this.$el.html(
      template({
        canInviteMembers:
          !board.hasInvitationRestrictions() && board.canInviteMembers(),
        includeOrgMembers:
          (board.getOrganization() != null && board.canInviteMembers()) ||
          this.model.getBoard().isEditableByTeamMemberAndIsNotABoardMember(),
        placeholder: l('add member placeholder'),
      }),
    );

    this.renderMems();
    return this.renderSuggested();
  }

  getSearch() {
    return $('.js-search-mem', this.$el).val().trim();
  }

  filteredMembers(members, search) {
    const satisfiesSearch = searchFilter(search);

    return _.chain(members)
      .filter((mem) => {
        return satisfiesSearch(Util.getMemNameArray(mem));
      })
      .first(8)
      .value();
  }

  filteredBoardMembers(term) {
    const activeMembers = this.activeBoardMembers();

    const sortedMembers = activeMembers.sortBy((member) => {
      const prefix = Auth.isMe(member)
        ? 0
        : this._onCardMembers[member.id]
        ? 1
        : this._onListMembers[member.id]
        ? 2
        : this._onBoardMembers[member.id]
        ? 3
        : 4;

      return prefix + member.get('fullName');
    });

    if (term) {
      return this.filteredMembers(sortedMembers, term);
    } else {
      return sortedMembers;
    }
  }

  filteredOrgMembers(term) {
    if (this.showOrgSection()) {
      const org = this.model.getBoard().getOrganization();
      if (
        (org != null ? org.paysWithPurchaseOrder() : undefined) &&
        (org != null ? org.isPremium() || org.isStandard() : undefined)
      ) {
        if (this.orgMembersPromise == null) {
          this.orgMembersPromise = ModelLoader.loadOrganizationMembersDataWithAvailableLicenseCount(
            org.id,
          );
        }
      } else {
        if (this.orgMembersPromise == null) {
          this.orgMembersPromise = ModelLoader.loadOrganizationMembersData(
            org.id,
          );
        }
      }

      return this.orgMembersPromise.then((members) => {
        const nonBoardMembers = org.memberList
          .filterDeactivated({ force: true })
          .without(
            ...Array.from(this.model.getBoard().memberList.models || []),
          );

        if (term) {
          return this.filteredMembers(nonBoardMembers, term);
        } else {
          return nonBoardMembers;
        }
      });
    } else {
      return [];
    }
  }

  hasSearch() {
    return this.getSearch() !== '';
  }

  showOrgSection() {
    // Only include team members if they've started searching or clicked on the
    // "Show team members" button … we want to keep the UI simple for the
    // common case
    const org = this.model.getBoard().getOrganization();
    return org != null && (this.showAllOrgMembers || this.hasSearch());
  }

  renderMems() {
    const term = this.getSearch();
    const boardMemList = this.filteredBoardMembers(term);
    const orgMemList = this.filteredOrgMembers(term);

    const sections = {
      '.js-board-members': boardMemList,
      '.js-org-members': orgMemList,
    };

    const showOrgSection = this.showOrgSection();
    $('.js-show-org-members', this.$el).toggleClass('hide', showOrgSection);
    $('.js-invite-results', this.$el).toggleClass(
      'hide',
      !Util.checkEmail(term),
    );

    if (this._renderMemsPromise != null) {
      this._renderMemsPromise.cancel();
    }
    this._renderMemsPromise = Promise.each(_.keys(sections), (selector) => {
      // eslint-disable-next-line @trello/enforce-variable-case
      const $section = $(selector, this.$el);
      if ($section.length === 0) {
        return;
      }

      // eslint-disable-next-line @trello/enforce-variable-case
      const $loading = $section.find('.js-loading');
      // eslint-disable-next-line @trello/enforce-variable-case
      const $noResults = $section.find('.js-no-results');

      $loading.removeClass('hide');
      $noResults.addClass('hide');

      return Promise.resolve(sections[selector]).then((memList) => {
        $loading.addClass('hide');

        // eslint-disable-next-line @trello/enforce-variable-case
        const $memList = $section.find('.js-mem-list');
        $memList.toggleClass(
          'collapsed',
          memList.length > MAX_EXPANDED_MEMBERS,
        );
        $noResults.toggleClass('hide', memList.length > 0);

        if (memList.length > 0) {
          $('.js-board-members', this.$el).removeClass('hide');
          $('.js-invite-no-results', this.$el).addClass('hide');
          $('.js-org-members', this.$el).toggleClass('hide', !showOrgSection);
        }

        const subviews = Array.from(memList).map((mem) =>
          this.subview(SelectMemberOnCardView, mem, {
            showUnconfirmed: true,
            card: this.model,
          }),
        );

        return this.ensureSubviews(subviews, $memList);
      });
    })
      .cancellable()
      .then(() => {
        if (this.hasSearch()) {
          // eslint-disable-next-line @trello/enforce-variable-case
          const $elem = this.$el.find('.item').first();
          if ($elem.length > 0) {
            return Util.selectMenuItem(this.$el, '.item', $elem);
          } else {
            return this.renderEmailInviteToSearchResults({ email: term });
          }
        }
      })
      .done();
    return this;
  }

  activeBoardMembers() {
    return this.model.getBoard().memberList.filterDeactivated({ force: true });
  }

  renderSuggested() {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $suggestions = $('.js-suggestions', this.$el);

    const suggestedMembers = this.getSuggestedMembers();

    const showSuggestions =
      !this.hasSearch() &&
      suggestedMembers.length > 0 &&
      // Don't bother showing suggestions if we can already see
      // all of the members and their full names
      this.activeBoardMembers().length > MAX_EXPANDED_MEMBERS;

    $suggestions.toggleClass('hide', !showSuggestions);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $memberList = $suggestions.find('.js-mem-list');

    if (showSuggestions) {
      const subviews = suggestedMembers.map((member) => {
        return this.subview(
          SelectMemberOnCardView,
          member,
          { card: this.model },
          `join-suggestion-${member.id}`,
        );
      });

      this.ensureSubviews(subviews, $memberList);
      Analytics.sendViewedComponentEvent({
        componentType: 'section',
        componentName: 'suggestedMembersSection',
        source: 'cardMemberSelectInlineDialog',
        attributes: {
          totalSuggestedMembers: suggestedMembers.length,
        },
        containers: {
          card: { id: this.model.id },
          board: { id: this.model.get('idBoard') },
          list: { id: this.model.get('idList') },
          organization: { id: this.model.getBoard()?.get('idOrganization') },
        },
      });
    } else {
      $memberList.empty();
    }

    return this;
  }

  getSuggestedMembers() {
    const history = ActionHistory.get();

    const idList = this.model.get('idList');

    const suggested = new Set();

    const joinEntry = { action: { type: 'join', idMember: Auth.myId() } };
    const addMemberEntries = history
      .filter(
        ({ action, context }) =>
          action.type === 'add-member' && context.idList === idList,
      )
      .filter(function ({ action }) {
        if (suggested.has(action.idMember)) {
          return false;
        } else {
          suggested.add(action.idMember);
          return true;
        }
      });

    return [joinEntry, ...Array.from(addMemberEntries)]
      .filter(({ action }) => this.model.isValidSuggestion(action))
      .map(({ action }) => {
        return this.modelCache.get('Member', action.idMember);
      })
      .slice(0, MAX_SUGGESTIONS)
      .sort(function (a, b) {
        if (Auth.isMe(a)) {
          return -1;
        } else if (Auth.isMe(b)) {
          return 1;
        } else {
          const aFullName = a.get('fullName').toLowerCase();
          const bFullName = b.get('fullName').toLowerCase();
          return aFullName.localeCompare(bFullName);
        }
      });
  }

  hoverMemberSelect(e) {
    return Util.selectMenuItem(this.$el, '.item', e.currentTarget);
  }

  keydownEvent(e) {
    const key = getKey(e);

    if ([Key.Tab, Key.Enter].includes(key)) {
      stopPropagationAndPreventDefault(e);
      $('.js-mem-list .item.selected:first .js-select-member', this.$el)
        .first()
        .click();
      $('.js-search-mem', this.$el).val('');
      this.focusSearch();
      this.renderMems();
    } else if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
      stopPropagationAndPreventDefault(e);
      Util.navMenuList(this.$el, '.item', key);
    }
  }

  updateSearch(e) {
    $('.js-invite-error', this.$el).addClass('hide');
    this.renderMems();
    return this.focusSearch();
  }

  selectMem(e) {
    stopPropagationAndPreventDefault(e);
    const { model } = this;

    // eslint-disable-next-line @trello/enforce-variable-case
    const $mem = $(e.currentTarget);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $item = $mem.closest('.item');
    const idMem = $mem.attr('idMember');
    const source = this.options.source || 'cardMemberSelectInlineDialog';

    if ($item.hasClass('active')) {
      const traceId =
        // Do not trace CardComposer member toggling
        model.typeName === 'Card'
          ? Analytics.startTask({
              taskName: 'edit-card/idMembers',
              source,
            })
          : '';

      model.removeMemberWithTracing(
        idMem,
        traceId,
        tracingCallback(
          {
            taskName: 'edit-card/idMembers',
            traceId,
            source,
          },
          (_err, res) => {
            if (res) {
              Analytics.sendUpdatedCardFieldEvent({
                field: 'idMembers',
                source,
                containers: {
                  card: { id: model.id },
                  board: { id: model.get('idBoard') },
                  list: { id: model.get('idList') },
                  organization: { id: model.getBoard()?.get('idOrganization') },
                },
                attributes: {
                  taskId: traceId,
                  changeType: 'remove member',
                },
              });
            }
          },
        ),
      );

      $item.removeClass('active');
    } else {
      const board = this.model.getBoard();
      const member = ModelCache.get('Member', idMem);

      if (!board.hasActiveMembership(member)) {
        if (
          Auth.isMe(member) &&
          model.getBoard().isEditableByTeamMemberAndIsNotABoardMember()
        ) {
          Alerts.show(
            'woohoo-you-are-now-a-member-of-this-board',
            'info',
            'join-board',
            4000,
          );

          board.optimisticJoinBoard();
        }
      }

      const traceId =
        // Do not trace CardComposer member toggling
        model.typeName === 'Card'
          ? Analytics.startTask({
              taskName: 'edit-card/idMembers',
              source,
            })
          : '';

      model.addMemberWithTracing(
        idMem,
        traceId,
        tracingCallback(
          {
            taskName: 'edit-card/idMembers',
            traceId,
            source,
          },
          (_err, res) => {
            if (res) {
              Analytics.sendUpdatedCardFieldEvent({
                field: 'idMembers',
                source,
                containers: {
                  card: { id: model.id },
                  board: { id: model.get('idBoard') },
                  list: { id: model.get('idList') },
                  organization: { id: model.getBoard()?.get('idOrganization') },
                },
                attributes: {
                  taskId: traceId,
                  changeType: 'add member',
                },
              });
            }
          },
        ),
      );

      $item.addClass('active');

      // Tracking for adding invitees to cards
      const boardMembers = this.model.getBoard().memberList.models;
      const myId = Auth.me().id;
      return boardMembers.forEach(function (boardMember) {
        if (
          boardMember.get('id') === idMem &&
          boardMember.get('idMemberReferrer') === myId
        ) {
          return Analytics.sendTrackEvent({
            action: 'added',
            actionSubject: 'invitee',
            source,
            attributes: {
              member: myId,
              addedMember: idMem,
            },
            containers: {
              card: { id: model.id },
              board: { id: model.get('idBoard') },
              list: { id: model.get('idList') },
              organization: { id: model.getBoard()?.get('idOrganization') },
            },
          });
        }
      });
    }

    this.focusSearch();
  }

  addSuggestedMember(e) {
    stopPropagationAndPreventDefault(e);

    const idMember = $(e.currentTarget, this.$el).attr('idMember');
    const source = 'cardMemberSelectInlineDialog';

    const traceId = Analytics.startTask({
      taskName: 'edit-card/idMembers',
      source,
    });

    this.model.addMemberWithTracing(
      idMember,
      traceId,
      tracingCallback(
        {
          taskName: 'edit-card/idMembers',
          traceId,
          source,
        },
        (_err, res) => {
          if (res) {
            Analytics.sendUpdatedCardFieldEvent({
              field: 'idMembers',
              source,
              containers: {
                card: { id: this.model.id },
                board: { id: this.model.get('idBoard') },
                list: { id: this.model.get('idList') },
                organization: {
                  id: this.model.getBoard()?.get('idOrganization'),
                },
              },
              attributes: {
                taskId: traceId,
                changeType: Auth.isMe(idMember) ? 'join' : 'add member',
              },
            });
          }
        },
      ),
    );

    this.focusSearch();
  }

  focusSearch() {
    $('.js-search-mem', this.$el).focus();
  }

  showOrgMembers(e) {
    this.showAllOrgMembers = true;
    this.renderMems();
  }

  wouldBecomeBillableGuest(email) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const { ApiPromise } = require('app/scripts/network/api-promise');
    const board = this.model.getBoard();

    if (!board.hasOrganization()) {
      return Promise.resolve(false);
    }

    const org = board.getOrganization();
    if (org && !org.isFeatureEnabled('multiBoardGuests')) {
      return Promise.resolve(false);
    }

    return ApiPromise({
      url: '/1/search/members/',
      type: 'get',
      data: {
        idBoard: board != null ? board.id : undefined,
        query: email,
      },
      dataType: 'json',
    }).then((data) => {
      return data.length === 1 && data[0].wouldBecomeBillableGuest;
    });
  }

  renderEmailInviteToSearchResults(data) {
    $('.js-invite-no-results', this.$el).removeClass('hide');
    const puncSpacePattern = /[\s\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/;
    const puncPattern = /[\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/;

    const fullName = _.compact(
      Util.removeDomainFromEmailAddress(data.email).split(puncSpacePattern),
    )
      .join(' ')
      .replace(puncPattern, '');
    const board = this.model.getBoard();
    const org = board != null ? board.getOrganization() : undefined;

    _.extend(data, {
      fullName: Util.toTitleCase(fullName),
      canAddAsObserver:
        org != null ? org.isFeatureEnabled('observers') : undefined,
      modelType: 'Board',
      isLoading: true,
      isOrgAdmin: org != null ? org.owned() : undefined,
      isDesktop,
    });

    const isEmailSearch = Util.checkEmail(data.email);
    const canInvite =
      !(board != null ? board.hasInvitationRestrictions() : undefined) &&
      isEmailSearch &&
      (board != null ? board.canInviteMembers() : undefined);

    $('.js-board-members', this.$el).addClass('hide');
    $('.js-org-members', this.$el).addClass('hide');

    if (canInvite) {
      $('.js-invite-no-results', this.$el).addClass('hide');
      $('.js-invite-results', this.$el)
        .html(inviteAddNameTemplate(data))
        .removeClass('hide');

      if (this.wouldBecomeBillableGuestPromise != null) {
        this.wouldBecomeBillableGuestPromise.cancel();
      }
      return (this.wouldBecomeBillableGuestPromise = this.wouldBecomeBillableGuest(
        data.email,
      )
        .cancellable()
        .then((wouldBecomeBillableGuest) => {
          // Update the email form template to remove the loading state and prepare
          // the MBG alert if necessary
          _.extend(data, {
            isLoading: false,
            wouldBecomeBillableGuest,
            availableLicenseCount:
              org != null ? org.getAvailableLicenseCount() : Infinity,
          });
          $('.js-invite-results', this.$el).html(inviteAddNameTemplate(data));

          // Inject the mbg alert if necessary (lets the user know about any extra billing, or why
          // they are not allowed to invite)
          if (wouldBecomeBillableGuest) {
            // eslint-disable-next-line @trello/enforce-variable-case
            const Element = (
              <InviteMemberAutocompleteMultiBoardGuestAlert
                displayOrg={{
                  url: org.get('url'),
                  availableLicenseCount: org.getAvailableLicenseCount(),
                }}
                isDesktop={isDesktop}
                isWorkspaceAdmin={org.owned()}
                workspaceAdmins={org.adminList.map(
                  (member) => member.get('fullName') || member.get('username'),
                )}
              />
            );
            if (
              (this.reactRoot = this.el.querySelector(
                '.js-billable-guests-alert',
              ))
            ) {
              return ReactDOM.render(Element, this.reactRoot);
            }
          }
        })
        .catch(ApiError, (restOrApiError) => {
          const error = localizeServerError(restOrApiError);
          _.extend(data, {
            isLoading: false,
            error,
          });
          return $('.js-invite-results', this.$el).html(
            inviteAddNameTemplate(data),
          );
        })
        .catch(Promise.CancellationError));
    }
  }

  _getNewMemberId(updatedMemberIds, existingMemberIds, newMemberRole, email) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const { ApiPromise } = require('app/scripts/network/api-promise');
    const newMemberId = _.first(
      _.difference(updatedMemberIds, existingMemberIds),
    );

    if (newMemberId != null) {
      Analytics.sendTrackEvent({
        action: 'sent',
        actionSubject: 'emailBoardInvitation',
        source: 'cardMemberSelectInlineDialog',
        containers: {
          card: { id: this.model.id },
          board: { id: this.model.get('idBoard') },
          list: { id: this.model.get('idList') },
          organization: { id: this.model.getBoard()?.get('idOrganization') },
        },
        attributes: {
          newMemberRole,
        },
      });
      return Promise.resolve(newMemberId);
    }

    // Someone with this email already belonged to the board, so they couldn't
    // be invited or added. Use server search to find who it is and add them to
    // the card.
    const requestData = _.extend(
      { query: email },
      this.model.getBoard().getInviteURLParams(),
    );

    const searchParams = {
      url: '/1/search/members/',
      type: 'get',
      data: requestData,
      dataType: 'json',
    };
    return ApiPromise(searchParams).then((results) => {
      if (results.length > 0) {
        // server-side search by email does an exact search, so this should
        // always return only one result
        return results[0].id;
      }
    });
  }

  sendEmailInvite(e) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const { ApiPromise } = require('app/scripts/network/api-promise');
    stopPropagationAndPreventDefault(e);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $sendButton = $('.js-send-email-invite', this.$el);
    // The email is already being sent
    if ($sendButton.attr('disabled') != null) {
      return;
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    const $name = $('.js-email-data .js-full-name', this.$el);
    const name = $name.val().trim();

    const email = $('.js-email-data .js-email', this.$el).val().trim();

    if (!Util.validName(name)) {
      Util.setCaretAtEnd($name);
      $('.js-name-error').show();
      return;
    } else if (containsValidUrl(name)) {
      // Urls are not allowed as member names
      Util.setCaretAtEnd($name);
      $('.js-name-error-url').show();
      return;
    }

    const data = {
      fullName: name,
      email,
      type: 'normal',
      allowBillableGuest: true,
    };

    if ($('#addAsObserver', this.$el).is(':checked')) {
      data.type = 'observer';
    }

    const board = this.model.getBoard();

    if (maybeDisplayMemberLimitsError($(e.target), board)) {
      return;
    }

    // Disable the button while we're sending the invite
    $sendButton.attr('disabled', 'disabled');

    const existingMembers = _.pluck(board.memberList.models, 'id');

    ApiPromise({
      url: `/1/board/${board.id}/members`,
      type: 'put',
      data,
    })
      .then(({ members }) => {
        const updatedMemberIds = _.pluck(members, 'id');
        return this._getNewMemberId(
          updatedMemberIds,
          existingMembers,
          data.type,
          email,
        );
      })
      .then((newMemberId) => {
        if (newMemberId != null) {
          const source = 'cardMemberSelectInlineDialog';
          const traceId = Analytics.startTask({
            taskName: 'edit-card/idMembers',
            source,
          });

          this.model.addMemberWithTracing(
            newMemberId,
            traceId,
            tracingCallback(
              {
                taskName: 'edit-card/idMembers',
                traceId,
                source,
              },
              (_err, res) => {
                if (res) {
                  Analytics.sendUpdatedCardFieldEvent({
                    field: 'idMembers',
                    source,
                    containers: {
                      card: { id: this.model.id },
                      board: { id: this.model.get('idBoard') },
                      list: { id: this.model.get('idList') },
                      organization: {
                        id: this.model.getBoard()?.get('idOrganization'),
                      },
                    },
                    attributes: {
                      taskId: traceId,
                      changeType: 'add member',
                    },
                  });

                  $('.js-send-email-invite', this.$el).prop('disabled', false);
                  return PopOver.hide();
                }
              },
            ),
          );

          return this;
        }
      })
      .catch(ApiError, (resOrApiError) => {
        const message = localizeServerError(resOrApiError);

        $('.js-invite-error', this.$el)
          .removeClass('hide')
          .find('.error')
          .html(message);
        $('.js-uninvited-search-results', this.$el).empty().hide();

        $sendButton.prop('disabled', false);
        $('js-search-mem').focus().select();

        sendErrorEvent(resOrApiError);
      });
  }
}

CardMemberSelectView.initClass();
export { CardMemberSelectView };
